import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="container-portal flex min-h-[58vh] flex-col items-center justify-center py-16 text-center">
        <p className="font-label text-[80px] leading-none text-background-300 md:text-[120px]">404</p>
        <h1 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">这个页面还没有内容</h1>
        <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">
          链接可能已失效，或页面仍在筹备中，你可以先从首页开始浏览影视资讯。
        </p>
        <p className="mt-2 break-all font-label text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-movie-2-line" />
            浏览电影
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}